import React from 'react';

type Props = {
  iconUrl?: string | null;
  logoUrl?: string | null;
  name: string;
  style?: React.CSSProperties;
};

export const BrandLogo = ({
  iconUrl, logoUrl, name, style,
}: Props) => {
  const sources = Array.from(new Set([iconUrl, logoUrl].filter((url): url is string => !!url)));
  const [attempt, setAttempt] = React.useState(0);
  const src = sources[attempt];

  React.useEffect(() => {
    setAttempt(0);
  }, [iconUrl, logoUrl]);

  if (!src) {
    return (
      <div className="FreeTrial__Brand__Logo FreeTrial__Brand__Logo--placeholder" style={style}>
        {name.trim().charAt(0).toUpperCase()}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={name}
      className="FreeTrial__Brand__Logo"
      onError={() => setAttempt((current) => current + 1)}
    />
  );
};
